import { useSelector } from "react-redux";
import { useAppDispatch } from "../../store";
import { IApplicationState } from "../../store";
import { FetchProfileAction } from "../../store/Profile/ActionCreator";
import { ReactElement, useEffect, useState } from "react";
import { BaseTable, Loading } from "@sede-enterprise/shell-ds-react-framework";
import { getProfileColumns } from "./ProfileHelper";
import { DefaultLayout } from "../../components";
import { FeatureHeadings } from "../../services";
import { LoadingIndicator } from "../../components/LoadingIndicator/LoadingIndicator";
import { CellInfo } from "../../core/types";
import styled from "styled-components";

export const ProfilePage: React.FC = () => {
  const TableStyled = styled(BaseTable)`
    width: 99.9%;
  `;

  const dispatch = useAppDispatch();
  const isLoading = useSelector(
    (state: IApplicationState) => state.profile.loading
  );
  const profileData = useSelector(
    (state: IApplicationState) => state.profile.profile
  );
  const [alertMessage] = useState("");

  useEffect(() => {
    if (!isLoading && (!profileData || Object.keys(profileData as object).length === 0)) {
      dispatch(FetchProfileAction());
    }
  }, [profileData, isLoading, dispatch]);

  const renderValue = (value: any) => {
    if (Array.isArray(value)) {
      return value.map((role, index) => <div key={index}>{role}</div>);
    }
    return <div>{value}</div>;
  };

  const EmptyComponent = (): ReactElement => {
    return <b>There&apos;s no data</b>;
  };

  const generateTableData = () => {
    const data: { columnName: string; value: any }[] = [];
    for (const key in profileData) {
      if (profileData.hasOwnProperty(key)) {
        data.push({
          columnName: getProfileColumns(key),
          value: (profileData as any)[key],
        });
      }
    }
    return data;
  };

  return (
    <div data-testid="ProfileTest">
      <DefaultLayout
        title={FeatureHeadings.Profile}
        message={alertMessage}
        children={
          isLoading ? (
            <LoadingIndicator />
          ) : (
            <>
              <TableStyled
                data-testid="ProfileTable"
                data={generateTableData()}
                columns={[
                  {
                    header: "Fields",
                    accessorKey: "columnName",
                  },
                  {
                    header: "Information",
                    accessorKey: "value",
                    cell: (info: CellInfo) => renderValue(info.getValue()),
                  },
                ]}
                key="corridorCode"
                size="small"
                emptyStateProps={<EmptyComponent />}
              />
            </>
          )
        }
      />
    </div>
  );
};
